"use client";

import { ChangeEvent, ComponentPropsWithRef, forwardRef, useId, useMemo } from "react";
import { ControllerFieldState, ControllerRenderProps } from "react-hook-form";

import cn from "@/utils/cn";

export interface RadioProps extends ComponentPropsWithRef<"input"> {
  name: string;
  label?: string;
  field?: ControllerRenderProps;
  fieldState?: ControllerFieldState;
}

const RadioBase = forwardRef<HTMLInputElement, RadioProps>(({ name, label, field, fieldState, ...rest }, ref) => {
  const defaultID = useId();
  const radioClass = cn("radio", rest?.className);
  const radioID = useMemo(() => {
    return rest?.id ? rest.id : defaultID;
  }, [rest, defaultID]);
  return (
    <div className={radioClass}>
      <input
        {...rest}
        {...field}
        onChange={(event: ChangeEvent<HTMLInputElement>) => {
          rest?.onChange?.(event as ChangeEvent<HTMLInputElement>);
          field?.onChange(event);
        }}
        className="appearance-none"
        id={radioID}
        ref={field?.ref ?? ref}
        name={name}
        aria-label={label}
        type="radio"
      />
      <label htmlFor={radioID}>
        <span dangerouslySetInnerHTML={{ __html: label as string }} />
      </label>
    </div>
  );
});
RadioBase.displayName = "RadioBase";
export default RadioBase;
